import { KeenIcon } from '@/components';
import { forwardRef } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

const SpecialityModal = forwardRef(({
  open,
  onCloseModal,
  handleMode,
  data,
  onSubmit,
  createFieldLoading,
  updateFieldLoading
}, formikRef) => {
  if (!open) return null;
  const isEditMode = handleMode === 'edit';

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
  });

  const initialValues = {
    name: data?.name || '',
  };

  return (
    <div className="modal-wrapper modal-animate-fade">

      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        innerRef={formikRef}
        onSubmit={(values, formikHelpers) => {
          onSubmit(values, formikHelpers)
        }}
      >

        {({ handleSubmit }) => (
          <Form onSubmit={handleSubmit} className="modal-animate-scale scrollable-y-auto bg-[--tw-navbar-bg] dark:bg-[--tw-navbar-bg-dark] border border-gray-300 dark:border-t-light dark:border-light p-6 rounded-lg shadow-lg w-4/5 max-w-xl relative">
            <h3 className="mb-5 capitalize card-title">
              {isEditMode ? 'Edit' : 'Create'} Specialty
            </h3>
            <button
              type="button"
              onClick={onCloseModal}
              className="modal-close-btn"
            >
              <KeenIcon icon="cross" />
            </button>

            <div className='w-full mb-3'>
              <label className="mb-1 form-label">Name <span className='pl-px text-red-600'>*</span></label>
              <Field name="name" className="input" />
              <ErrorMessage name="name" component="div" className="mt-1 text-xs text-red-500" />
            </div>

            <button type="submit" disabled={createFieldLoading || updateFieldLoading} className="justify-center w-full mt-2 btn btn-primary">
              {isEditMode
                ? updateFieldLoading ? 'Please Wait...' : 'Update Specialty'
                : createFieldLoading ? 'Please wait...' : 'Create Specialty'}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
});

export { SpecialityModal };
